import classNames from 'classnames'
import { FC, HTMLAttributes } from 'react'

import ArrowIcon from 'assets/img/shared/arrow1.svg?react'
import s from './ButtonPromo.module.scss'

interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
  variant?: 'white' | 'purple' | 'pink' | 'arrow' | 'darkGray' | 'link' | 'outlined'
  fullWidth?: boolean
  disabled?: boolean
  round?: boolean
  style?: React.CSSProperties
  className?: string
}

export const ButtonPromo: FC<ButtonProps> = ({
  children,
  variant = 'purple',
  fullWidth = false,
  disabled = false,
  round = false,
  style,
  className,
  onClick,
  ...props
}) => {
  const classes = classNames(s.btn, [s[variant]], className, {
    [s.fullWidth]: fullWidth,
    [s.disabled]: disabled,
    [s.round]: round,
  })

  return (
    <button className={classes} onClick={onClick} style={style} disabled={disabled} {...props}>
      {variant === 'arrow' ? <ArrowIcon className={s.arrowIcon} /> : children}
    </button>
  )
}
